import React, {useState} from 'react'
import {TimePicker} from '@material-ui/pickers'
import {Grid} from '@material-ui/core'
import Input from 'Components/Input'
import moment from 'moment'

moment.locale('fr')

export default React.memo(props => {
  const [hour, setHour] = useState(props.value && props.value !== 'NULL' ? moment(props.value, 'HH:mm').format('YYYY-MM-DD HH:mm') : undefined)
  const onChange = (time) => {
    setHour(time.format('YYYY-MM-DD HH:mm'))
  }
  return (
    <Grid container style={{
      position: 'relative',
      marginBottom: 5,
      ...(props.style || {})
    }} alignItems={'stretch'} direction={'column'}
          justify={'center'}>
      <TimePicker
        label={props.title}
        ampm={false}
        TextFieldComponent={Input}
        key={props.value}
        variant="inline"
        onClose={() => {
          props.onChange(moment(hour).format('HH:mm'), props.name)
        }}
        inputVariant="outlined"
        InputProps={{ style: { marginBottom: 0 } }}
        id={props.id || ''}
        className={(props.className || '') + ' pull pull-left'}
        value={props.value && props.value !== 'NULL' ? moment(props.value, 'HH:mm').format('YYYY-MM-DD HH:mm') : ''}
        style={Object.assign({}, props.style || {})}
        onChange={onChange}
        disabled={props.disabled}/>
    </Grid>
  )
})



// WEBPACK FOOTER //
// ./app/Components/TimePicker.js